<template>
    <div class="content-wrapper">
        <section class="content-header">
            <div class="row">
                <div class="col-xs-6">
                    <h1>{{ isEdit ? 'Edit Campaign' : 'Add Campaign' }}</h1>
                </div>
                <div class="col-xs-6 mandatoryDiv">
                    <span class="mandatory_color">(*)</span>
                    <span class="letter-right"> Marked are required field</span>
                </div>
            </div>
        </section>
        <section class="content">
            <div class="row">
                <div class="col-sm-12">
                    <div class="alert alert-info" v-if="alert_message">
                        {{ alert_message }}
                    </div>
                    <div class="alert alert-danger" v-if="error_message">
                        {{ error_message }}
                    </div>
                </div>
                <form @submit.prevent="formSubmit">
                    <div class="col-sm-12">
                        <div class="box">
                            <div class="box-header">
                                <h3 class="box-title">Campaign Information</h3>
                            </div>
                            <div class="box-body form-box-body form-horizontal">
                                <div class="form-group">
                                    <label class="col-md-2 control-label">
                                        Campaign Name
                                        <span class="mandatory_horizontal">*</span>
                                    </label>
                                    <div class="col-md-4">
                                        <input type="text" v-model="formData.name" id="name" name="name"
                                            placeholder="Enter Campaign Name" required maxlength="100"
                                            class="form-control input-sm" />
                                        <small v-if="errors.name" class="text-danger">{{ errors.name }}</small>
                                    </div>
                                    <label class="col-md-2 control-label">
                                        Show As Name
                                        <span class="mandatory_horizontal">*</span>
                                    </label>
                                    <div class="col-md-4">
                                        <input type="text" v-model="formData.show_as_name" id="show_as_name"
                                            name="show_as_name" placeholder="Enter Show As Name" required maxlength="50"
                                            class="form-control input-sm" />
                                        <small v-if="errors.show_as_name" class="text-danger">{{ errors.show_as_name
                                            }}</small>
                                    </div>
                                </div>

                                <div class="form-group">
                                    <label class="col-md-2 control-label">
                                        Coupon Code
                                        <span class="mandatory_horizontal">*</span>
                                    </label>
                                    <div class="col-md-4">
                                        <input type="text" v-model="formData.coupon_code" id="coupon_code"
                                            name="coupon_code" placeholder="Enter Coupon Code" required maxlength="100"
                                            class="form-control input-sm" />
                                        <small v-if="errors.coupon_code" class="text-danger">{{ errors.coupon_code
                                            }}</small>
                                    </div>
                                    <label class="col-md-2 control-label">
                                        Website Hero Image
                                    </label>
                                    <div class="col-md-4">
                                        <input type="text" v-model="formData.website_hero_img" id="website_hero_img"
                                            name="website_hero_img" placeholder="Enter Image URL" maxlength="150"
                                            class="form-control input-sm" />
                                    </div>
                                </div>

                                <!-- <div class="form-group">
                                    <label class="col-md-2 control-label">
                                        Discount Type
                                        <span class="mandatory_horizontal">*</span>
                                    </label>
                                    <div class="col-md-4">
                                        <select v-model="formData.discount_type" class="form-control input-sm" required>
                                            <option value="1">Fixed</option>
                                            <option value="2">Percentage</option>
                                        </select>
                                        <small v-if="errors.discount_type" class="text-danger">{{ errors.discount_type
                                            }}</small>
                                    </div>
                                    <label class="col-md-2 control-label">
                                        Discount Amount
                                        <span class="mandatory_horizontal">*</span>
                                    </label>
                                    <div class="col-md-4">
                                        <input type="number" v-model="formData.discount_amount" id="discount_amount"
                                            name="discount_amount" placeholder="Enter Discount Amount" required min="0"
                                            step="0.01" class="form-control input-sm" />
                                        <small v-if="errors.discount_amount" class="text-danger">{{
                                            errors.discount_amount }}</small>
                                    </div>
                                </div> -->

                                <div class="form-group">
                                    <label class="col-md-2 control-label">
                                        Affiliate Share (%)
                                    </label>
                                    <div class="col-md-4">
                                        <input type="number" v-model="formData.affiliate_share_percent"
                                            id="affiliate_share_percent" name="affiliate_share_percent"
                                            placeholder="Enter Affiliate Share Percent" min="0" step="0.01"
                                            class="form-control input-sm" />
                                    </div>
                                    <label class="col-md-2 control-label">
                                        Status
                                    </label>
                                    <div class="col-md-4">
                                        <select v-model="formData.status" class="form-control input-sm">
                                            <option value="1">Active</option>
                                            <option value="0">Inactive</option>
                                        </select>
                                    </div>
                                </div>

                                <div class="form-group">
                                    <label class="col-md-2 control-label">
                                        Start At
                                        <span class="mandatory_horizontal">*</span>
                                    </label>
                                    <div class="col-md-4">
                                        <input type="datetime-local" v-model="formData.start_at" id="start_at"
                                            name="start_at" required class="form-control input-sm" />
                                        <small v-if="errors.start_at" class="text-danger">{{ errors.start_at }}</small>
                                    </div>
                                    <label class="col-md-2 control-label">
                                        End At
                                        <span class="mandatory_horizontal">*</span>
                                    </label>
                                    <div class="col-md-4">
                                        <input type="datetime-local" v-model="formData.end_at" id="end_at" name="end_at"
                                            required class="form-control input-sm" />
                                        <small v-if="errors.end_at" class="text-danger">{{ errors.end_at }}</small>
                                    </div>
                                </div>

                                <div class="form-group">
                                    <label class="col-md-2 control-label">Remarks</label>
                                    <div class="col-md-10">
                                        <textarea v-model="formData.remarks" id="remarks" name="remarks"
                                            placeholder="Enter Remarks" maxlength="250" class="form-control input-sm"
                                            rows="3"></textarea>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-sm-12 btnCenter">
                            <input type="submit" name="submit" :value="isEdit ? 'Update' : 'Save Now'"
                                class="btn btn-sm btn-submit btn-submit-big" />
                            <router-link :to="{ name: 'CampaignCouponList' }" class="btn btn-sm btn-cancel">
                                Cancel
                            </router-link>
                        </div>
                    </div>
                </form>
            </div>
        </section>
    </div>
</template>

<script>
import axios from "axios";

export default {
    name: "CampaignCouponForm",
    data() {
        return {
            alert_message: "",
            error_message: "",
            campaignId: null,
            isEdit: false,
            formData: {
                name: "",
                show_as_name: "",
                coupon_code: "",
                website_hero_img: "",
                discount_type: "1",
                discount_amount: "0.00",
                affiliate_share_percent: "",
                start_at: "",
                end_at: "",
                status: "1",
                remarks: "",
            },
            errors: {},
        };
    },
    created() {
        this.com_user_type_access([0, 5, 6, 7], true);
        this.campaignId = this.$route.params.id;
        if (this.campaignId) {
            this.isEdit = true;
            this.loadCampaignData();
        }
    },
    methods: {
        loadCampaignData() {
            loader.show();
            axios
                .get("/campaigns/" + this.campaignId)
                .then((response) => {
                    let data = response.data.result;
                    this.formData.name = data.name;
                    this.formData.show_as_name = data.show_as_name;
                    this.formData.coupon_code = data.coupon_code;
                    this.formData.website_hero_img = data.website_hero_img || "";
                    this.formData.discount_type = 1; // Defaulting to Fixed as per original code
                    this.formData.discount_amount = 0.00; // Defaulting to 0 as per original code
                    this.formData.affiliate_share_percent = data.affiliate_share_percent || "";
                    this.formData.start_at = this.formatDateTimeForInput(data.start_at);
                    this.formData.end_at = this.formatDateTimeForInput(data.end_at);
                    this.formData.status = data.status;
                    this.formData.remarks = data.remarks || "";
                    loader.hide();
                })
                .catch((error) => {
                    loader.hide();
                    this.com_errorHandel(error);
                });
        },
        formatDateTimeForInput(datetime) {
            if (!datetime) return "";
            return datetime.slice(0, 16).replace(" ", "T");
        },
        formatDateTimeForAPI(datetime) {
            if (!datetime) return "";
            return datetime.replace("T", " ") + ":00";
        },
        formValidation() {
            this.errors = {};
            let validationFlag = false;

            if (!this.formData.name) {
                this.errors.name = "Please enter campaign name";
                validationFlag = true;
            }
            if (!this.formData.show_as_name) {
                this.errors.show_as_name = "Please enter show as name";
                validationFlag = true;
            }
            if (!this.formData.coupon_code) {
                this.errors.coupon_code = "Please enter coupon code";
                validationFlag = true;
            }
            // if (!this.formData.discount_type) {
            //     this.errors.discount_type = "Please select discount type";
            //     validationFlag = true;
            // }
            // if (!this.formData.discount_amount) {
            //     this.errors.discount_amount = "Please enter discount amount";
            //     validationFlag = true;
            // }
            if (!this.formData.start_at) {
                this.errors.start_at = "Please select start date";
                validationFlag = true;
            }
            if (!this.formData.end_at) {
                this.errors.end_at = "Please select end date";
                validationFlag = true;
            }
            if (this.formData.start_at && this.formData.end_at) {
                if (new Date(this.formData.start_at) >= new Date(this.formData.end_at)) {
                    this.errors.end_at = "End date must be after start date";
                    validationFlag = true;
                }
            }

            return validationFlag;
        },
        formSubmit() {
            if (this.formValidation()) {
                return;
            }

            let rootObject = this;
            loader.show();

            let payload = {
                ...this.formData,
                start_at: this.formatDateTimeForAPI(this.formData.start_at),
                end_at: this.formatDateTimeForAPI(this.formData.end_at),
            };

            if (this.isEdit) {
                axios
                    .put("/campaigns/" + this.campaignId, payload)
                    .then(function (response) {
                        if (response.data.result) {
                            rootObject.alert_message = response.data.message || "Campaign Updated Successfully";
                            setTimeout(() => {
                                rootObject.$router.push({ name: "CampaignCouponList" });
                            }, 1500);
                        }
                        loader.hide();
                    })
                    .catch(function (error) {
                        loader.hide();
                        if (error.response && error.response.data) {
                            rootObject.error_message = error.response.data.message || "Failed to update campaign";
                        }
                        rootObject.com_errorHandel(error);
                    });
            } else {
                axios
                    .post("/campaigns", payload)
                    .then(function (response) {
                        if (response.data.result) {
                            rootObject.alert_message = response.data.message || "Campaign Created Successfully";
                            setTimeout(() => {
                                rootObject.$router.push({ name: "CampaignCouponList" });
                            }, 1500);
                        }
                        loader.hide();
                    })
                    .catch(function (error) {
                        loader.hide();
                        if (error.response && error.response.data) {
                            rootObject.error_message = error.response.data.message || "Failed to create campaign";
                        }
                        rootObject.com_errorHandel(error);
                    });
            }
        },
    },
};
</script>

<style scoped>
.text-danger {
    color: red;
}
</style>